import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import CustomMap from "../../Components/Map";
import { BrandDetails, BrandOffers } from "./brands-and-offers";

import { BackIcon } from "./nn-icons";
import { getUserId } from "../../Utils/helpers";
import { useGetFidelNearestLocations } from "../../CustomHooks/Queries";

function NeighborhoodNetworkOffersNearYou() {
  const residentId = getUserId();
  const [offerId, setOfferId] = useState(null);
  const navigate = useNavigate();

  const { data } = useGetFidelNearestLocations(
    { resident_id: residentId },
    { enabled: !!residentId }
  );

  const allOffers = useMemo(() => {
    return data?.pages?.flatMap((page) => page?.data?.data || []) || [];
  }, [data]);

  const selectedOffer = useMemo(() => {
    if (!offerId) return null;
    return allOffers.find(
      (offer) => String(offer.offer_id) === String(offerId)
    );
  }, [offerId, allOffers]);

  const latitude = Number(
    selectedOffer?.latitude ?? selectedOffer?.offer?.latitude
  );

  const longitude = Number(
    selectedOffer?.longitude ?? selectedOffer?.offer?.longitude
  );

  const shouldHighlight = !!latitude && !!longitude && !isNaN(latitude) && !isNaN(longitude);

  return (
    <div className="nn-page neighborhood-network offers-near-you anim-ready">
      <section>
        <div className="offers-container">
          <div className="section-header">
            <button
              type="button"
              className="nn-back-btn"
              onClick={() =>
                !offerId ? navigate(-1) : setOfferId(null)
              }
              aria-label="Go back"
            >
              <BackIcon />
            </button>

            <h3 className="section-title">
              {!offerId ? "Near you" : "Offer Details"}
            </h3>

            <div className="dummy"></div>
          </div>

          {!offerId ? (
            <BrandOffers
              filterByLocality
              setOfferId={setOfferId}
              hideBrandTypeFilter
            />
          ) : (
            <BrandDetails
              offerId={offerId}
              residentId={residentId}
              embedMap={false}
              
            />
          )}
        </div>

        <CustomMap
          residentId={residentId}
          expanded
          latitude={latitude}
          longitude={longitude}
          highlightSingle={shouldHighlight}
        />
      </section>
    </div>
  );
}

export default NeighborhoodNetworkOffersNearYou;